import { connectSlack, getSlack, deleteSlack } from '@/service/slack'

const initialState = () => ({
  data: {
    loadingSlackConnect: false,
    loadingSlack: false,
    slack: null,
  },
})

const state = initialState()

const getters = {
  loadingSlackConnect: state => state.data.loadingSlackConnect,
  loadingSlack: state => state.data.loadingSlack,
  slack: state => state.data.slack,
}

const actions = {
  connectSlack({ commit }, { code }) {
    commit('startLoadingSlackConnect')
    connectSlack(code).then(data => {
      commit('setSlackIntegration', data)
      commit('stopLoadingSlackConnect')
    })
  },
  getSlack({ commit }) {
    commit('startLoadingSlack')
    getSlack().then(data => {
      commit('setSlackIntegration', data)
      commit('stopLoadingSlack')
    })
  },
  deleteSlack({ commit }, { id }) {
    commit('startLoadingSlack')
    deleteSlack(id).then(() => {
      getSlack().then(data => {
        commit('setSlackIntegration', data)
        commit('stopLoadingSlack')
      })
    })
  },
}

const mutations = {
  setSlackIntegration(state, { slack }) {
    state.data.slack = slack
  },
  startLoadingSlackConnect(state) {
    state.data.loadingSlackConnect = true
    state.data.slack = null
  },
  stopLoadingSlackConnect(state) {
    state.data.loadingSlackConnect = false
  },
  startLoadingSlack(state) {
    state.data.loadingSlack = true
    state.data.slack = null
  },
  stopLoadingSlack(state) {
    state.data.loadingSlack = false
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
